// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  subscriptions: [],
  companyReference: {},
  topics: [],
  developerEmails: [],
}

export const mutations = {
  SET_SUBSCRIPTIONS(state, subscriptions) {
    state.subscriptions = subscriptions
  },
  SET_COMPANY_REFERENCE(state, companyReference) {
    state.companyReference = companyReference
  },
  SET_TOPICS(state, topics) {
    state.topics = topics
  },
  ADD_WEBHOOK_SUBSCRIPTION(state, subscription) {
    state.subscriptions.push(subscription)
  },
  SET_WEBHOOK_DEVELOPER_EMAILS(state, developerEmails) {
    state.developerEmails = developerEmails
  },
  ADD_WEBHOOK_DEVELOPER_EMAIL(state, developerEmail) {
    state.developerEmails.push(developerEmail)
  },
  EDIT_WEBHOOK_DEVELOPER_EMAIL(state, developerEmail) {
    const index = state.developerEmails.findIndex(
      (devEmail) => devEmail.developer_uuid === developerEmail.developer_uuid
    )
    if (index !== -1) {
      state.developerEmails.splice(index, 1, developerEmail)
    }
  },
  DELETE_WEBHOOK_DEVELOPER_EMAIL(state, developer_uuid) {
    const index = state.developerEmails.findIndex(
      (admin) => admin.developer_uuid === developer_uuid
    )
    if (index !== -1) {
      state.developerEmails.splice(index, 1)
    }
  },
  EDIT_WEBHOOK_SUBSCRIPTION(state, subscription) {
    const index = state.subscriptions.findIndex(
      (sub) => sub.subscription_uuid === subscription.subscription_uuid
    )
    if (index !== -1) {
      state.subscriptions.splice(index, 1, subscription)
    }
  },
  DELETE_WEBHOOK_SUBSCRIPTION(state, subscription_uuid) {
    const index = state.subscriptions.findIndex(
      (sub) => sub.subscription_uuid === subscription_uuid
    )
    if (index !== -1) state.subscriptions.splice(index, 1)
  },
}

export const actions = {
  fetchWebhookSubscriptions({ commit }, payload) {
    return ApiService.fetchWebhookSubscriptions(payload)
      .then((res) => {
        const subscriptions = res.data.data
        commit('SET_SUBSCRIPTIONS', subscriptions)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchWebhookCompanyReference({ commit }, payload) {
    return ApiService.fetchWebhookCompanyReference(payload)
      .then((res) => {
        const companyReference = res.data
        commit('SET_COMPANY_REFERENCE', companyReference)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchWebhookTopics({ commit }, payload) {
    return ApiService.fetchWebhookTopics(payload)
      .then((res) => {
        const topics = res.data.data
        commit('SET_TOPICS', topics)
      })
      .catch((error) => {
        throw error
      })
  },
  addWebhookSubscription({ commit }, payload) {
    return ApiService.addWebhookSubscription(payload)
      .then((res) => {
        const subscription = res.data
        commit('ADD_WEBHOOK_SUBSCRIPTION', subscription)
      })
      .catch((error) => {
        throw error
      })
  },
  editWebhookSubscription({ commit }, payload) {
    return ApiService.editWebhookSubscription(payload)
      .then((res) => {
        const subscription = res.data
        commit('EDIT_WEBHOOK_SUBSCRIPTION', subscription)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteWebhookSubscription({ commit }, payload) {
    return ApiService.deleteWebhookSubscription(payload)
      .then(() => {
        commit('DELETE_WEBHOOK_SUBSCRIPTION', payload.subscription_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchWebhookDeveloperEmails({ commit }, payload) {
    return ApiService.fetchWebhookDeveloperEmails(payload)
      .then((res) => {
        const developerEmails = res.data.data
        commit('SET_WEBHOOK_DEVELOPER_EMAILS', developerEmails)
      })
      .catch((error) => {
        throw error
      })
  },
  addWebhookDeveloperEmail({ commit }, payload) {
    return ApiService.addWebhookDeveloperEmail(payload)
      .then((res) => {
        const developerEmail = res.data
        commit('ADD_WEBHOOK_DEVELOPER_EMAIL', developerEmail)
      })
      .catch((error) => {
        throw error
      })
  },
  editWebhookDeveloperEmail({ commit }, payload) {
    return ApiService.editWebhookDeveloperEmail(payload)
      .then((res) => {
        const developerEmail = res.data
        commit('EDIT_WEBHOOK_DEVELOPER_EMAIL', developerEmail)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteWebhookDeveloperEmail({ commit }, payload) {
    return ApiService.deleteWebhookDeveloperEmail(payload)
      .then(() => {
        const developer_uuid = payload.developer_uuid
        commit('DELETE_WEBHOOK_DEVELOPER_EMAIL', developer_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  testPingWebhook(_, payload) {
    return ApiService.testPingWebhook(payload)
      .then((res) => {
        // Handle success response if needed
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  webhookResendTransaction(_, payload) {
    return ApiService.webhookResendTransaction(payload)
      .then((res) => {
        // Handle success response if needed
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
